import { Link } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import Button from '../Button';
import FontAwesomeIcon from '../Icon';
import { Hidden } from '../Table';
import SparkSyncCell from 'src/components/SparkSyncCell/SparkSyncCell';
import { checkSparkDataAvailable } from 'src/helpers/validationHelper';
import { variables } from 'src/Tenants';
import { ReactElement } from 'react';
import WalkthroughSyncCell from 'src/components/WalkthroughSyncCell/WalkthroughSyncCell';

export interface TableColumn {
  label?: string;
  accessor?: string;
  sortable?: boolean;
  center?: boolean;
  xsHide?: boolean;
  cell?: (data: any) => ReactElement | null;
  minWidth?: string
  width?: string
}

export interface CreatePropertiesTableColumnsParams {
  userRoleName: string;
  onEditProperty: (data: any) => void;
  onDeleteProperty: (data: any) => void;
  onNavigateToProperty: () => void;
  onWalkthroughSyncToggle: (propertyId: string, newSuspendedState: boolean) => void;
}

export const createPropertiesTableColumns = ({
  userRoleName,
  onEditProperty,
  onDeleteProperty,
  onNavigateToProperty,
  onWalkthroughSyncToggle
}: CreatePropertiesTableColumnsParams): TableColumn[] => {
  const isAdminOrSuperAdmin: boolean =
    userRoleName === 'Admin' || userRoleName === 'Super Admin';

  const isRestrictedRole: boolean =
    userRoleName === 'Home Owner' || userRoleName === 'Occupant';

  return [
    {
      label: 'Property',
      accessor: 'name',
      sortable: true,
      minWidth: '16rem',
      cell: (data: any) => (
        <Link
          onClick={onNavigateToProperty}
          to={PATHS.PROPERTIES_VIEW.replace(':id', data.id)}
        >
          {data.name}
        </Link>
      ),
    },
    {
      label: 'Address',
      sortable: true,
      accessor: 'addressLine1',
      minWidth: '16rem',
    },
    {
      center: false,
      xsHide: true,
      sortable: true,
      label: variables.Suite + 's',
      accessor: 'suits',
      minWidth: '9rem',
    },
    {
      center: false,
      xsHide: true,
      sortable: true,
      label: variables.serviceRequest + 's',
      accessor: 'serviceRequests',
      minWidth: '11rem',
    },
    {
      center: false,
      xsHide: true,
      sortable: true,
      label: 'Automatic Walkthrough Sync',
      width: '24rem',
      cell: (data: any) => {
        return (
          <WalkthroughSyncCell
            propertyId={data.id}
            syncAutomationSuspended={data.syncAutomationSuspended}
            onToggleSuccess={onWalkthroughSyncToggle}
          />
        );
      },
    },
    {
      label: 'Spark Sync',
      xsHide: true,
      sortable: true,
      width: '13rem',
      accessor: 'isSpark',
      cell: (data: any) => (
        <SparkSyncCell propertyId={data.id} isSpark={data.isSpark} />
      ),
    },
    {
      width: '8rem',
      cell: (data: any) => {
        if (checkSparkDataAvailable(data, userRoleName) || isRestrictedRole) {
          return null;
        }

        return (
          <Hidden>

              <Button
                color="semantic"
                label={<FontAwesomeIcon glyph="pencil" weight="light" />}
                onClick={() => onEditProperty(data)}
              />
              {isAdminOrSuperAdmin && (
                <Button
                  color="semantic"
                  onClick={() => onDeleteProperty(data)}
                  label={<FontAwesomeIcon glyph="trash" weight="light" />}
                />
              )}
          </Hidden>
        );
      },
    },
  ];
};